import React from 'react';
import { Button } from '@shared/ui/button';
import { Check } from 'lucide-react';

interface SimpleSuccessScreenProps {
  title: string;
  ticketId: string;
  description?: string;
  primaryButtonText?: string;
  secondaryButtonText?: string;
  onPrimaryClick: () => void;
  onSecondaryClick: () => void;
}

export const SimpleSuccessScreen: React.FC<SimpleSuccessScreenProps> = ({
  title,
  ticketId,
  description = "Our team will address it within the committed timeline.",
  primaryButtonText = "View Requests",
  secondaryButtonText = "Raise Another",
  onPrimaryClick,
  onSecondaryClick,
}) => {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-4 bg-white rounded-xl shadow-sm border border-gray-200 mt-2">
      <div className="w-24 h-24 bg-green-50 rounded-full flex items-center justify-center mb-6">
        <div className="w-12 h-12 rounded-full border-[3px] border-green-500 flex items-center justify-center">
          <Check className="w-6 h-6 text-green-500 stroke-[3]" />
        </div>
      </div>
      
      <h2 className="text-3xl font-bold text-[#1e293b] mb-4">{title}</h2>
      
      {/* <div className="text-gray-600 text-lg mb-2">
        Ticket ID: <span className="font-bold text-blue-700">{ticketId}</span>
      </div> */}
      
      <p className="text-gray-500 mb-10 text-center max-w-md">
        {description}
      </p>
      
      <div className="flex items-center gap-4">
        <Button 
          onClick={onPrimaryClick}
          className="bg-blue-600 hover:bg-blue-700 text-white font-medium px-6 py-2.5 h-auto text-base rounded-lg"
        >
          {primaryButtonText}
        </Button>
        <Button 
          variant="outline"
          onClick={onSecondaryClick}
          className="bg-white border-gray-300 text-gray-700 hover:bg-gray-50 font-medium px-6 py-2.5 h-auto text-base rounded-lg"
        >
          {secondaryButtonText}
        </Button>
      </div>
    </div>
  );
};
